import { useEffect, useState } from "react";
export const useUncontrolledAndControlled = ({ defaultValue, value, onValueChange, }) => {
    const [internalValue, setInternalValue] = useState(value !== undefined ? value : defaultValue);
    const handleValueChange = (newValue) => {
        if (newValue !== undefined) {
            onValueChange?.(newValue);
        }
        if (value === undefined) {
            setInternalValue(newValue);
        }
    };
    useEffect(() => {
        if (value !== undefined) {
            setInternalValue(value);
        }
    }, [value]);
    return { internalValue, handleValueChange };
};
//# sourceMappingURL=uncontrolled-and-controlled.js.map